<template>
	<lnk-combinefilter ref="filter"
					   class="lnk-combinefilter-service"
					   @change="handleChange"
					   @save="handleSave"
					   :interface-path="interfacePath"
					   :context="context"
					   :show.sync="show"></lnk-combinefilter>
</template>

<script>
function isFunc(v) {
	return typeof v === 'function'
}

export default {
	name: "comfilter-picker",
	data() {
		return {
			show: false,
			filter: null,
			interfacePath: '',
			filterOptions: [],
			filterResults: [],
			onConfirm: null,
			onSave: null,
          	// 关联的列表的context
          	context: this.$parent,
        }
	},
	methods: {
		handleChange(filtersRaw, filterOperator) {
			if (!isFunc(this.onConfirm)) return;
			this.onConfirm(filtersRaw, [...this.filter.results, {
				isLogicConfig: true,
				isDiyLogic: this.filter.isDiyLogic,
				logicOperator: this.filter.logicOperator,
			}], filterOperator);
		},
		handleSave() {
			if (!isFunc(this.onSave)) return;
			this.onSave(...arguments);
		},
		async openPicker(opts) {
			const {filterOptions, filterResults, onConfirm, interfacePath, onSave} = opts;
			const combFilter = this.filter;
			this.interfacePath = interfacePath;
			this.onConfirm = onConfirm;
			this.onSave = onSave;
			this.show = true;
			await combFilter.initOptions(filterOptions);
			await this.$lv.nextTick();
			if (filterResults.length) {
				combFilter.restoreResults(filterResults);
			}
		}
	},
	mounted() {
		this.filter = this.$refs.filter;
	}
}
</script>

<style scoped>

</style>
